import { Table } from 'antd';
import styled from '@emotion/styled';
import { isInteger, sum } from 'lodash';

const CustomTable = styled(Table)((props) => ({
  maxWidth: 'unset',
  table: {
    borderRadius: 0,
    border: props?.withBorder ? '1px solid #000' : 'unset',
  },
  '.ant-table-thead': {
    backgroundColor: '#1B2531',
    th: {
      background: '#1B2531 !important',
    },
  },
  '.ant-table-thead > tr > th:not(:last-child), .ant-table-tbody > tr > td:not(:last-child)': {
    borderRight: '1px solid #5a6c79',
    borderRadius: '0 !important',
  },
  '.checkbox-center': {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default function TableHeros(props) {
  const columnx = props.columns.map((ss) => ss?.width || 100);
  const showSequence = props?.columns?.filter((ss) => ss?.dataIndex === 'index')?.length > 0;
  const dataSource = props?.dataSource || [];
  const includesPage = props?.pagination?.page && isInteger(props?.pagination?.page);
  const ps = dataSource.map((ss, i) => ({
    ...ss,
    index: includesPage ? i + 1 + 10 * (props?.pagination?.page - 1) : i + 1,
  }));

  return (
    <CustomTable
      {...props}
      rowKey={props?.rowKey || '_id'}
      dataSource={!showSequence ? dataSource : ps}
      withBorder
      scroll={{
        x: sum(columnx),
      }}
    />
  );
}
